import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const styles = {
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
};

const concept = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h5">Stink-o-Meter</Typography>
      An electrochemical nose is an array made up of chemical gas sensors housed
      in a device that uses pattern recognition to recognize, identify, and
      compare odors. The proposed Stink-o-Meter, is an e-nose, specifically
      designed and trained for detecting bad odors. The objective is to monitor
      and map all regions of India with this low-cost open source module and
      create open data source. If that sounds too bold, a practical use case is
      management of public garbage bins and toilets in India.
      <div className={classes.imgdiv}>
        <img className={classes.img} src="./Schematic1.jpg" alt="e-nose" />
      </div>{" "}
      <Typography variant="h6">Swachh Bharat Mission</Typography>
      <Typography className={classes.para} paragraph>
        Swachh Bharat Abhiyan or Swachh Bharat Mission is a nation-wide campaign
        in India for the period 2014 to 2019 that aims to clean up the streets,
        roads and infrastructure of India's cities, towns, and rural areas. The
        campaign's official name is in Hindi and translates to "Clean India
        Mission" in English.
        <br />I wish to create more public awareness about this mission by
        crowd-sourcing stink data through Internet-of-Smell thingy.
        infrastructure.
      </Typography>
      <Typography variant="h6">Stink Source</Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./project/The-Smell-of-Garbage.png"
          alt="Rhino"
        />
      </div>{" "}
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./project/The-Smell-of-Toilets-and-Human-Waste.png"
          alt="Rhino"
        />
      </div>{" "}
    </div>
  );
};

export default withStyles(styles)(concept);
